module.exports = __webpack_public_path__ + "static/kran04_3840-5018e1ca576c7f9d3d14296c4a0a2189.jpg";